import { TasksPortalConfiguration } from '../types';

export const tasksDefaultConfig: TasksPortalConfiguration = {
  isAutoTaskEnabledForTradeRef: false,
};
